import { useCookies } from "react-cookie";
import { Locale } from "../config";
import Cookies from "js-cookie";

const LOCALE_COOKIE_NAME = "locale";

export function useLocaleCookie() {
  const [cookies, setCookie] = useCookies<
    typeof LOCALE_COOKIE_NAME,
    { locale: Locale }
  >([LOCALE_COOKIE_NAME]);

  const setLocaleCookie = (locale: Locale) => {
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);

    return setCookie(LOCALE_COOKIE_NAME, locale, {
      path: "/",
      secure: true,
      expires: expires,
    });
  };

  return {
    localeCookie: cookies.locale,
    setLocaleCookie,
  };
}

export function getLocaleCookie() {
  return Cookies.get(LOCALE_COOKIE_NAME) as Locale;
}
